var _line, _path, _ellipse, _path2, _path3, _rect, _mask, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClientStep1Bulb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 213,
    viewBox: "0 0 146 213",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 74.1123,
    y1: 49,
    x2: 74.1123,
    y2: 1.53267e-8,
    stroke: "url(#paint0_linear_3701_8206)",
    strokeWidth: 0.701267
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.5229 56.3994C81.5229 54.5395 80.7841 52.7558 79.4689 51.4407C78.1538 50.1256 76.3701 49.3867 74.5102 49.3867C72.6504 49.3867 70.8667 50.1256 69.5515 51.4407C68.2364 52.7558 67.4976 54.5395 67.4976 56.3994L74.5102 56.3994H81.5229Z",
    fill: "url(#paint1_linear_3701_8206)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.8038,
    cy: 5.2595,
    rx: 29.8038,
    ry: 5.2595,
    transform: "matrix(-1 0 0 1 104.313 79.1904)",
    fill: "url(#paint2_linear_3701_8206)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M44.7057 84.0518H104.313L145.513 196.549H0L44.7057 84.0518Z",
    fill: "url(#paint3_linear_3701_8206)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.313 84.4493C104.313 76.5449 101.173 68.9642 95.5834 63.3748C89.9941 57.7855 82.4134 54.6455 74.5089 54.6455C66.6044 54.6455 59.0237 57.7855 53.4344 63.3748C47.8451 68.9641 44.7051 76.5449 44.7051 84.4493L74.5089 84.4493H104.313Z",
    fill: "url(#paint4_linear_3701_8206)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 60.9116,
    y: 120.163,
    width: 27.1029,
    height: 27.1029,
    rx: 13.5514,
    stroke: "url(#paint5_linear_3701_8206)",
    strokeWidth: 6.04
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-1_3701_8206",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.671 183.429C102.213 183.429 103.477 182.176 103.329 180.641C103.053 177.789 102.356 174.988 101.255 172.331C99.798 168.812 97.6619 165.616 94.969 162.923C92.2761 160.23 89.0792 158.094 85.5607 156.636C82.0423 155.179 78.2712 154.429 74.4629 154.429C70.6546 154.429 66.8835 155.179 63.3651 156.636C59.8466 158.094 56.6497 160.23 53.9568 162.923C51.2639 165.616 49.1278 168.812 47.6704 172.331C46.5698 174.988 45.8726 177.789 45.5972 180.641C45.449 182.176 46.7129 183.429 48.2548 183.429C49.7967 183.429 51.0295 182.174 51.213 180.643C51.4667 178.525 52.0094 176.447 52.8292 174.468C54.0059 171.627 55.7308 169.045 57.9052 166.871C60.0795 164.697 62.6609 162.972 65.5019 161.795C68.3429 160.618 71.3878 160.013 74.4629 160.013C77.5379 160.013 80.5829 160.618 83.4239 161.795C86.2649 162.972 88.8462 164.697 91.0206 166.871C93.195 169.045 94.9198 171.627 96.0966 174.468C96.9164 176.447 97.459 178.525 97.7128 180.643C97.8962 182.174 99.1291 183.429 100.671 183.429Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.671 183.429C102.213 183.429 103.477 182.176 103.329 180.641C103.053 177.789 102.356 174.988 101.255 172.331C99.798 168.812 97.6619 165.616 94.969 162.923C92.2761 160.23 89.0792 158.094 85.5607 156.636C82.0423 155.179 78.2712 154.429 74.4629 154.429C70.6546 154.429 66.8835 155.179 63.3651 156.636C59.8466 158.094 56.6497 160.23 53.9568 162.923C51.2639 165.616 49.1278 168.812 47.6704 172.331C46.5698 174.988 45.8726 177.789 45.5972 180.641C45.449 182.176 46.7129 183.429 48.2548 183.429C49.7967 183.429 51.0295 182.174 51.213 180.643C51.4667 178.525 52.0094 176.447 52.8292 174.468C54.0059 171.627 55.7308 169.045 57.9052 166.871C60.0795 164.697 62.6609 162.972 65.5019 161.795C68.3429 160.618 71.3878 160.013 74.4629 160.013C77.5379 160.013 80.5829 160.618 83.4239 161.795C86.2649 162.972 88.8462 164.697 91.0206 166.871C93.195 169.045 94.9198 171.627 96.0966 174.468C96.9164 176.447 97.459 178.525 97.7128 180.643C97.8962 182.174 99.1291 183.429 100.671 183.429Z",
    stroke: "url(#paint6_linear_3701_8206)",
    strokeWidth: 14.0857,
    mask: "url(#path-7-inside-1_3701_8206)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3701_8206",
    x1: 74.4629,
    y1: 24.5,
    x2: 75.4629,
    y2: 24.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#402C5E",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8865BD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3701_8206",
    x1: 68.4874,
    y1: 52.7093,
    x2: 81.4347,
    y2: 52.5654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#711CF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115733,
    stopColor: "#8D42FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222473,
    stopColor: "#AB86E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34481,
    stopColor: "#9E7ECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555237,
    stopColor: "#6C44A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#290A58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3701_8206",
    x1: 4.20695,
    y1: 2.49194,
    x2: 59.0223,
    y2: -0.959398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#711CF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115733,
    stopColor: "#8D42FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222473,
    stopColor: "#AB86E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34481,
    stopColor: "#9E7ECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555237,
    stopColor: "#6C44A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#290A58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3701_8206",
    x1: 72.7564,
    y1: 84.0518,
    x2: 72.7564,
    y2: 196.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#975EFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246075,
    stopColor: "#38117D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B2268",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3701_8206",
    x1: 48.912,
    y1: 68.7665,
    x2: 103.938,
    y2: 68.1551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#711CF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115733,
    stopColor: "#8D42FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222473,
    stopColor: "#AB86E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34481,
    stopColor: "#9E7ECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555237,
    stopColor: "#6C44A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#290A58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3701_8206",
    x1: 74.463,
    y1: 117.143,
    x2: 74.463,
    y2: 150.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7644C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B085F",
    stopOpacity: 0.89
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3701_8206",
    x1: 74.4629,
    y1: 154.429,
    x2: 74.4629,
    y2: 186.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D179D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D0E5D",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientStep1Bulb);
export default __webpack_public_path__ + "static/media/clientStep1Bulb.37092e29d80f2395249cca14baa6af85.svg";
export { ForwardRef as ReactComponent };